import React, { type ReactNode } from 'react';

import cx from '../../../utils/classNames';

import styles from '../button.module.scss';

/** Custom props */
type Props = {
  /** The content of the component */
  children?: ReactNode;
  /** Custom class to overwrite default styling if needed */
  className?: string;
};

export function Label(props: Props) {
  const { children, className } = props;

  const classNames = cx(styles.buttonLabel, className);

  return (
    <span className={classNames} data-testid="button-label">
      {children}
    </span>
  );
}

export default Label;
